export default function Team404Page() {
    return (
        <main>
      Page could not be found! 404.
        </main>
    );
}
